var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":64,"width":8,"color":"dark"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }